export const CONSTANTS = {
  INPUT_CHARACTERS_LIMIT: 2000,
  DESCRIPTION: 'description',
  FIRST_LEVEL_KEY: 'first_level_key',
  SECOND_LEVEL_KEY: 'second_level_key',
  THIRD_LEVEL_KEY: 'third_level_key',
  REQUEST_USER_PREFIX: 'requestUser.',
};
